import React from "react";

const Hero = () => {
  return (
    <section
      className="relative h-screen flex flex-col justify-center items-center text-white"
      style={{ backgroundImage: "url('/images/Kenzo.jpg')" }}
    >
      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-black/50 z-0"></div>

      {/* Hero Content */}
      <div className="relative z-10 px-4 text-center max-w-4xl">
        <h1 className="text-2xl md:text-6xl font-bold mb-6 animate-fadeIn">
          Unlocking Commercial Value Through Responsible Stewardship
        </h1>
        <p className="text-lg md:text-2xl mb-8 animate-fadeIn delay-200">
          ESG | Corporate Affairs | Strategist | 
        </p>
        <a
          href="#connect"
          className="inline-block bg-black hover:bg-black-700 text-white font-semibold py-3 px-8 rounded-lg shadow-lg transition-all transform hover:scale-105 animate-fadeIn delay-400"
        >
          Connect with Me
        </a>
      </div>
    </section>
  );
};

export default Hero;